import * as ActionTypes from './actionTypes'

export const fetchStart = layerId => () => ({
  type: ActionTypes.FETCH_START,
  layerId
})
export const fetchSuccess = (layerId, ai) => ({
  type: ActionTypes.FETCH_SUCCESS,
  layerId,
  ai
})
export const fetchFailure = (layerId, error) => ({
  type: ActionTypes.FETCH_FAILURE,
  layerId,
  error
})

export const selectAI = ids => ({
  type: ActionTypes.SELECT,
  ids
})
export const deselect = () => ({ type: ActionTypes.DESELECT })
export const prev = () => ({ type: ActionTypes.PREV })
export const next = () => ({ type: ActionTypes.NEXT })
